document.addEventListener("DOMContentLoaded", () => {
  // Use event delegation for more reliable event handling
  document.addEventListener("click", handleSizeInteractions);
  initSizeSelectors();

  // Re-initialize after cart updates
  //   document.addEventListener("cart:refresh", initSizeSelectors);
});

function handleSizeInteractions(event) {
  // Handle button clicks
  if (event.target.closest(".size-selector__button")) {
    const button = event.target.closest(".size-selector__button");
    event.preventDefault();
    event.stopPropagation();
    toggleSizeDropdown(button);
  }

  // Handle size option clicks
  if (event.target.closest(".size-selector__option")) {
    const option = event.target.closest(".size-selector__option");
    event.preventDefault();
    event.stopPropagation();
    handleSizeChange(option);
  }

  // Close all dropdowns when clicking elsewhere
  if (!event.target.closest(".cart-item__size-selector")) {
    closeAllSizeDropdowns();
  }
}

function initSizeSelectors() {
  // Just initialize the state, don't add event listeners
  closeAllSizeDropdowns();
}

function toggleSizeDropdown(button) {
  const dropdown = button.nextElementSibling;
  const isExpanded = button.getAttribute("aria-expanded") === "true";

  closeAllSizeDropdowns();

  if (!isExpanded) {
    button.setAttribute("aria-expanded", "true");
    dropdown.hidden = false;
  }
}

function closeAllSizeDropdowns() {
  const buttons = document.querySelectorAll(".size-selector__button");
  buttons.forEach((btn) => {
    btn.setAttribute("aria-expanded", "false");
    const dropdown = btn.nextElementSibling;
    if (dropdown) {
      dropdown.hidden = true;
    }
  });
}

function handleSizeChange(option) {
  const variantId = option.dataset.variantId;
  const currentVariantId = option
    .closest(".cart-item")
    .querySelector("[data-quantity-variant-id]").dataset.quantityVariantId;
  const quantity = parseInt(
    option.closest(".cart-item").querySelector(".quantity__input").value
  );
  const selectedSize = option.dataset.optionValue;

  if (variantId === currentVariantId) {
    closeAllSizeDropdowns();
    return; // Same size, no change needed
  }

  // Show loading state
  option.closest(".cart-item").classList.add("is-loading");

  // Update cart - remove current item and add new variant
  updateCartItem(currentVariantId, variantId, quantity)
    .then(() => {
      // Update the UI to show selection was successful
      option.closest(".cart-item").classList.remove("is-loading");

      // Update button text
      const button = option
        .closest(".cart-item__size-selector")
        .querySelector(".size-selector__button");

      // Create a new arrow SVG
      const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg.setAttribute("width", "10");
      svg.setAttribute("height", "6");
      svg.setAttribute("viewBox", "0 0 10 6");
      svg.setAttribute("fill", "none");

      const path = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "path"
      );
      path.setAttribute("d", "M1 1L5 5L9 1");
      path.setAttribute("stroke", "currentColor");
      path.setAttribute("stroke-width", "1.5");
      path.setAttribute("stroke-linecap", "round");

      svg.appendChild(path);

      // Set button content
      button.textContent = selectedSize + " ";
      button.appendChild(svg);

      closeAllSizeDropdowns();
    })
    .catch((error) => {
      console.error("Error updating size:", error);
      option.closest(".cart-item").classList.remove("is-loading");
      // Show error message
    });
}

async function updateCartItem(currentVariantId, newVariantId, quantity) {
  try {
    // First remove the current item
    await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: currentVariantId,
        quantity: 0,
      }),
    });

    // Then add the new variant
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: newVariantId,
        quantity: quantity,
      }),
    });

    // Get the updated cart data
    const cartResponse = await fetch("/cart.js");
    const cartData = await cartResponse.json();

    // Update cart count in the header if it exists
    const cartCountBubble = document.querySelector(".cart-count-bubble");
    if (cartCountBubble) {
      const itemCountSpan = cartCountBubble.querySelector(
        'span[aria-hidden="true"]'
      );
      if (itemCountSpan) {
        itemCountSpan.textContent = cartData.item_count;
      }
    }

    // Update just the cart drawer content via AJAX
    const cartDrawerResponse = await fetch("/?sections=cart-drawer");
    const responseData = await cartDrawerResponse.json();

    if (responseData["cart-drawer"]) {
      // Find the cart drawer contents container
      const cartDrawerContents = document.getElementById(
        "CartDrawer-CartItems"
      );

      // Create a temporary element to parse the HTML
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = responseData["cart-drawer"];

      // Extract the new contents
      const newContents = tempDiv.querySelector(".js-contents");

      if (newContents && cartDrawerContents) {
        // Replace the contents
        cartDrawerContents.innerHTML = newContents.innerHTML;

        // Re-initialize the functionality
        initSizeSelectors();

        // Initialize any other cart functionality
        if (typeof initQuantityButtons === "function") {
          initQuantityButtons();
        }
      }
    }

    return response.json();
  } catch (error) {
    console.error("Error updating cart:", error);
    throw error;
  }
}
